import { z } from "zod"

import type { WidgetSize } from "@productlane/db/browser"
import { WidgetIconType } from "@productlane/db/browser"

export const WidgetView = {
	DEFAULT: "DEFAULT",
	FEEDBACK: "FEEDBACK",
	CHANGELOG: "CHANGELOG",
}

export const WIDGET_SIZE_VALUES = ["SMALL", "MEDIUM", "LARGE"] as const

// Compile-time guard: these literals must stay in step with the Prisma enum.
const _widgetSizeValuesMatchPrisma: WidgetSize =
	"SMALL" satisfies (typeof WIDGET_SIZE_VALUES)[number]
void _widgetSizeValuesMatchPrisma

export const WidgetSettingsSchema = z.object({
	id: z.string(),
	workspaceId: z.string(),
	hasCustomLinksEnabled: z.boolean(),
	isChangelogEnabled: z.boolean(),
	isRoadmapEnabled: z.boolean(),
	isBrandingEnabled: z.boolean(),
	isFeedbackEnabled: z.boolean(),
	isWhatsNewEnabled: z.boolean(),
	isSupportEnabled: z.boolean(),
	isHelpCenterEnabled: z.boolean(),
	isLiveChatEnabled: z.boolean(),
	isWidgetIconVisible: z.boolean(),
	widgetIconType: z.nativeEnum(WidgetIconType),
	widgetSize: z.enum(WIDGET_SIZE_VALUES),
	isPortalAuthEnabled: z.boolean(),
	isGuestChatEnabled: z.boolean(),
	isAiFirstEnabled: z.boolean(),
	isContactAvatarsEnabled: z.boolean(),
	widgetLinks: z
		.array(
			z.object({
				id: z.string(),
				workspaceId: z.string(),
				title: z.string().nullable(),
				// Checked per link on save, so one bad link blocks only itself.
				url: z.string().nullable(),
				icon: z.string().nullable(),
			}),
		)
		.optional(),
	defaultView: z.enum([
		WidgetView.DEFAULT,
		WidgetView.FEEDBACK,
		WidgetView.CHANGELOG,
	]),
})
export type WidgetSettings = z.infer<typeof WidgetSettingsSchema>
